export const MAP_ROTATION_ANGLE = 0; // Unused, kept for compatibility
export const ROUTE_INDEX_CHANGE_THRESHOLD = 2; // min index steps of real progress before trusting a direction change (ignores ±1 jitter)
export const uberMapOptions = {
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  zoomControl: true,
  rotateControl: false,
  tilt: 0,
  styles: [
    {
      elementType: "geometry",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ],
};

export const POSITION_HISTORY_SIZE = 20;
export const MOVEMENT_THRESHOLD = 5; // meters
export const TERMINAL_THRESHOLD = 60; // meters
export const ROUTE_PROXIMITY_THRESHOLD = 100; // meters

export const CONSTANTS = {
  STOP_RADIUS: 50, // meters
  STOP_VISIT_TIME: 10, // seconds
  DEPARTURE_DISTANCE: 30, // meters
  LOOK_AHEAD_DISTANCE: 1000, // meters
  DATA_STALENESS_THRESHOLD: 30000, // ms
  EARTH_RADIUS: 6371e3,
  MAX_STOP_DISTANCE: 800, // meters
  MIN_STOP_DISTANCE: 100, // meters
  AVG_SPEED: 35, // km/h
  MIN_STOP_TIME: 10, // seconds
  MAX_STOP_TIME: 100, // seconds
  TRAFFIC_MULTIPLIER: 1.1,
};

export const colors = [
  "#20A8E0",
  "#8FBC8F",
  "#FFD700",
  "#6495ED",
  "#FF69B4",
  "#FFA07A",
  "#ADFF2F",
  "#FF4500",
  "#9370DB",
  "#FFFFFF",
];

export const MAP_ORIENTATION = {
  VERTICAL_ANGLE: 0,
  DEFAULT_ZOOM: 15,
  MIN_ZOOM: 13,
  MAX_ZOOM: 18,
  PADDING: 100
};